export const ONBOARDING_EMAIL_TEMPLATES = {
  BOOK_SETUP_CALL: {
    to: 'help@snug.com',
    subject: 'Book Online Training',
    body: `Hi Snug Team,

These are my preferred days and times to attend the Online Training:
[Days]: [Time]`,
  },

  LOGO_UPLOAD: {
    to: 'help@snug.com',
    subject: 'Logo Upload Request',
    body: `Hi Snug Team,

I would like to upload our agency logo. Please find it attached.

Thanks!`,
  },

  READY_FOR_SETUP_CALL: {
    to: 'help@snug.com',
    subject: 'Ready for Setup Call',
    body: `Hi Snug Team,

I am ready for my setup call to configure:
- Auto Responder settings
- Property Management System connection

Please let me know your available times for the setup call.

Best regards,`,
  },
}

export const createMailtoUrl = (template) => {
  const subject = encodeURIComponent(template.subject)
  const body = encodeURIComponent(template.body)
  return `mailto:${template.to}?subject=${subject}&body=${body}`
}
